import { getAttachmentKind, getAttachmentLabel } from './attachmentHelpers';

const ICONS = {
  pdf: '📄',
  word: '📝',
  excel: '📊',
  ppt: '📽',
  image: '🖼',
  text: '📃',
  file: '📎',
};

export default function AttachmentChip({ attach, onPreviewClick, compact, onRemove }) {
  const kind = getAttachmentKind(attach);
  const label = attach.fileName || 'File';
  const thumb = attach.preview || attach.imageData || attach.content;

  if (kind === 'image') {
    return (
      <div className={`msg-attachment msg-attachment--image${compact ? ' msg-attachment--compact' : ''}`}>
        {thumb ? (
          <button type="button" className="msg-attachment-image-btn" onClick={() => onPreviewClick?.(attach)} aria-label={`View ${label}`}>
            <img src={thumb} alt="" />
          </button>
        ) : (
          <span className="msg-attachment-icon" aria-hidden="true">
            {ICONS.image}
          </span>
        )}
        <div className="msg-attachment-meta">
          <span className="msg-attachment-type">{getAttachmentLabel(kind)}</span>
          <span className="msg-attachment-name">{label}</span>
        </div>
        {onRemove && (
          <button type="button" className="msg-attachment-remove" onClick={onRemove} aria-label="Remove">
            ×
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`msg-attachment msg-attachment--${kind}${compact ? ' msg-attachment--compact' : ''}`}>
      <span className="msg-attachment-icon" aria-hidden="true">
        {ICONS[kind] || '📎'}
      </span>
      <div className="msg-attachment-meta">
        <span className="msg-attachment-type">{getAttachmentLabel(kind)}</span>
        <span className="msg-attachment-name">{label}</span>
      </div>
      {onRemove && (
        <button type="button" className="msg-attachment-remove" onClick={onRemove} aria-label="Remove">
          ×
        </button>
      )}
    </div>
  );
}
